import React from 'react';
import { CloseButton, Drawer } from '@chakra-ui/react';

/**
 * Rounded close button for drawer headers — a circular hit area that only shows
 * its background on hover. Wraps Drawer.CloseTrigger, so it must live inside a
 * Drawer.Root. Extra props (e.g. flexShrink) pass through to the CloseButton.
 */
const DrawerCloseButton: React.FC<React.ComponentProps<typeof CloseButton>> = (props) => {
	return (
		<Drawer.CloseTrigger asChild>
			<CloseButton size="sm" rounded="full" _hover={{ bg: 'bg.emphasized' }} {...props} />
		</Drawer.CloseTrigger>
	);
};

export default DrawerCloseButton;
